let dogsField = [];
let products = [];
let servingGuide = [];
let recurrence = [];
let sgResultApi;
let isPetstock = document.querySelector('input[name="SG_petstock_page"]').value;

document.addEventListener("DOMContentLoaded", function () {
  validateSgForm();

  togglePopup();
  handlePopup();

  sgFormNextStep();

  sgCalculate();
  handleUpdateDog();
  btnSmartLink();

  sgEmail();
  sgShowMore();

  mixBrandPetzyo();
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

function validateSgForm() {
  if (document.querySelectorAll(".js-sg-name").length) {
    document.querySelectorAll(".js-sg-name").forEach((input) => {
      input.addEventListener("keyup", () => {
        checkValidateSgForm();
      });
    });
  }

  // if (document.querySelectorAll(".js-sg-weight").length) {
  //   document.querySelectorAll(".js-sg-weight").forEach((input) => {
  //     input.addEventListener("keyup", () => {
  //       checkValidateSgForm();
  //     });
  //   });
  // }

  // if (document.querySelectorAll(".js-sg-target-weight").length) {
  //   document.querySelectorAll(".js-sg-target-weight").forEach((input) => {
  //     input.addEventListener("keyup", () => {
  //       checkValidateSgForm();
  //     });
  //   });
  // }

  if (document.querySelectorAll(".js-sg-other-me").length) {
    document.querySelectorAll(".js-sg-other-me").forEach((input) => {
      input.addEventListener("keyup", () => {
        checkValidateSgForm();
      });
    });
  }

  if (document.querySelectorAll(".js-sg-other-new-product").length) {
    document.querySelectorAll(".js-sg-other-new-product").forEach((input) => {
      input.addEventListener("keyup", () => {
        checkValidateSgForm();
      });
    });
  }

  if (document.querySelectorAll('input[type="number"]').length) {
    document.querySelectorAll('input[type="number"]').forEach((input) => {
      input.addEventListener("keydown", (event) => {
        if ((event.which != 8 && event.which != 0 && event.which < 48) || event.which > 57) {
          event.preventDefault();
        }
      });
    });
  }
}

function togglePopup() {
  if (document.querySelectorAll(".js-open-sg-popup").length) {
    document.querySelectorAll(".js-open-sg-popup").forEach((elm) => {
      elm.addEventListener("click", () => {
        document.body.classList.add("sg-popup--opening");
        document.querySelector(".sg-popup").setAttribute("data-popup", elm.getAttribute("data-popup"));
      });
    });
  }

  if (document.querySelectorAll(".js-close-sg-popup").length) {
    document.querySelectorAll(".js-close-sg-popup").forEach((elm) => {
      elm.addEventListener("click", () => {
        document.body.classList.remove("sg-popup--opening");
        document.querySelector(".sg-popup").setAttribute("data-popup", "");

        pageLoad(false);
      });
    });
  }
}

function handlePopup() {
  // RETURNING USER Already filled in this form flow {is petzyo customer}

  // 1. Already filled out this form
  document.getElementById("Form-AlreadyFilled").addEventListener("submit", (e) => {
    e.preventDefault();

    pageLoad(true);

    let form = e.target,
      dogName = form.querySelector("#AFName").value.toLowerCase(),
      mail = form.querySelector('input[type="email"]').value,
      elem = document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]');

    setAttributes(elem, { "data-mail": mail, "data-dog": dogName });
    sendEmail(mail, false);
  });

  // Test without code validation
  // testFillDogData();

  // 2. Verify account to retrieve info
  document.getElementById("Form-ConfirmationCode").addEventListener("submit", (e) => {
    e.preventDefault();

    let form = e.target,
      code = form.querySelector("#CCCode").value;
    confirmationCode(code, false);
  });

  // 3. Select doggo names present in profile
  document.getElementById("Form-ChooseDog").addEventListener("submit", (e) => {
    e.preventDefault();

    let form = e.target,
      dogChecked = form.querySelector('input[name="choose_dogs"]:checked'),
      dogDataObj = dogChecked.parentNode.querySelector('[type="application/json"]').innerText,
      dogData = JSON.parse(dogDataObj),
      dogName = dogData.name;

    document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').setAttribute("data-dog", dogName);

    prePopulatedForm(dogData);
  });
}

function sendEmail(mail, checkPopup) {
  fetch("https://profileapp.petzyo.com.au/send-email", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      customerEmail: mail,
    }),
  })
    .then(() => {
      if (document.getElementById("CCCode").value != "") {
        document.getElementById("CCCode").value = "";
      }

      if (checkPopup) {
        document.body.classList.add("sg-popup--opening");
      }
      document.querySelector(".sg-popup").setAttribute("data-popup", "confirmation-code");
      pageLoad(false);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function confirmationCode(code) {
  pageLoad(true);

  let mail = document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').getAttribute("data-mail"),
    dogName = document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').getAttribute("data-dog");

  const verificationApi = await fetch("https://profileapp.petzyo.com.au/verify-email", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      customerEmail: mail,
      verifyCode: code,
    }),
  });

  const dataVerification = await verificationApi.json();

  if (dataVerification.isVerified) {
    checkCustomerData(mail, dogName, false);
  } else {
    pageLoad(false);
    alert("Wrong code");
  }
}

async function checkCustomerData(mail, dogName, checkPopup) {
  const customerApi = await fetch("https://profileapp.petzyo.com.au/check-customer-data", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      customerEmail: mail,
      dogName: dogName,
    }),
  });

  const dataCustomer = await customerApi.json();

  if (checkPopup) {
    document.body.classList.add("sg-popup--opening");
  }

  if (dataCustomer.isExist) {
    let elem = document.querySelector(".sg-step-2");

    setAttributes(elem, { "data-verify": true, "data-mail": mail, "data-status": "verify" });
    if (dataCustomer.data) {
      if (dataCustomer.isMatching) {
        if (document.querySelector(".page-serving-guide").classList.contains("step-2")) {
          document.querySelector(".sg-popup").setAttribute("data-popup", "update-dog");
          document.querySelector('.sg-popup-wrap[data-popup="update-dog"]').setAttribute("data-content", "match");
          pageLoad(false);
        } else {
          const dogData = dataCustomer.data[0];
          prePopulatedForm(dogData);
          document.body.classList.remove("sg-popup--opening");
          document.querySelector(".sg-popup").setAttribute("data-popup", "");
        }
      } else {
        const dogsData = dataCustomer.data;
        let html = "";

        dogsData.map(function (data) {
          html +=
            '<choose-dog><div class="sg-radio-wrap"><script type="application/json">' +
            JSON.stringify(data) +
            '</script><input type="radio" id="DogName-' +
            data.name +
            '" name="choose_dogs" value="' +
            data.name +
            '" required><label for="DogName-' +
            data.name +
            '">' +
            data.name +
            "</label></div></choose-dog>";
        });
        if (document.querySelector(".page-serving-guide").classList.contains("step-2")) {
          document.querySelector("#ChooseDogUpdateList").innerHTML = html;
          document.querySelector("#ChooseDogUpdateList").style.display = "block";
          document.querySelector(".js-sg-update-dog-btn").disabled = true;
          document.querySelector(".sg-popup").setAttribute("data-popup", "update-dog");
          document.querySelector('.sg-popup-wrap[data-popup="update-dog"]').setAttribute("data-content", "multi");
        } else {
          document.querySelector("#ChooseDogList").innerHTML = html;
          document.querySelector(".sg-popup").setAttribute("data-popup", "choose-dog");
        }
        pageLoad(false);
      }
    } else {
      if (document.querySelector(".page-serving-guide").classList.contains("step-2")) {
        document.querySelector(".sg-popup").setAttribute("data-popup", "update-dog");
        document.querySelector(".js-sg-update-dog-btn").setAttribute("data-action", "add");
        document.querySelector('.sg-popup-wrap[data-popup="update-dog"]').setAttribute("data-content", "add");
      } else {
        document.querySelector(".sg-popup").setAttribute("data-popup", "error-dog");
      }
      pageLoad(false);
    }
  } else {
    document.querySelector(".sg-popup").setAttribute("data-popup", "error-account");
    document.querySelector('.sg-popup-wrap[data-popup="error-account"] .js-error-account').innerText = mail;
    document.querySelector(".sg-step-2").setAttribute("data-status", "error");

    pageLoad(false);
  }
}

function prePopulatedForm(dogData) {
  let form;

  if (dogData.is_adult) {
    if (dogData.lifestage == "senior") {
      document.querySelector("#is_adult_senior").click();
    } else {
      document.querySelector("#is_adult_true").click();
    }
    form = document.querySelector('.sg-tab-content[data-form="adult"]');

    if (dogData.activity_level) {
      document.querySelector('.js-sg-activity-level[value="' + dogData.activity_level.toLowerCase() + '"]').click();
    }
    if (dogData.bodyshape) {
      document.querySelector('.js-sg-bodyshape[data-value="' + dogData.bodyshape.toLowerCase() + '"]').click();
    }
    if (dogData.weight) {
      // form.querySelector(".js-sg-weight").value = dogData.weight;
      form.querySelector('.js-sg-weight[data-value="' + dogData.weight + '"]').click();
    }
  } else {
    document.querySelector("#is_adult_false").click();
    form = document.querySelector('.sg-tab-content[data-form="puppy"]');

    if (dogData.puppyweight) {
      // form.querySelector(".js-sg-weight").value = dogData.puppyweight;
      form.querySelector('.js-sg-weight[data-value="' + dogData.puppyweight + '"]').click();
    }
    if (dogData.weight) {
      // form.querySelector(".js-sg-target-weight").value = dogData.weight;
      form.querySelector('.js-sg-target-weight[data-value="' + dogData.weight + '"]').click();
    }

    if (dogData.puppy_age_serving) {
      const week = parseInt(dogData.puppy_age_serving, 10);
      if (week > 0) {
        if (week >= 104) {
          document.querySelector('.js-puppy-age-serving[data-value="104"]').click();
        } else {
          document.querySelector('.js-puppy-age-serving[data-value="' + week + '"]').click();
        }
      }
    } else if (dogData.dob) {
      const oneDay = 24 * 60 * 60 * 1000;
      const mdy = dogData.dob.split("-");
      const firstDate = new Date(mdy[0], mdy[1] - 1, mdy[2]);
      const secondDate = Date.now();
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

      if (diffDays > 0) {
        const week = Math.round(Math.abs(diffDays / 7));
        if (week > 104) {
          document.querySelector('.js-puppy-age-serving[data-value="104"]').click();
        } else {
          document.querySelector('.js-puppy-age-serving[data-value="' + week + '"]').click();
        }
      }
    }
  }

  if (dogData.name) {
    document.querySelector(".js-sg-name").value = dogData.name;
  }

  // if (dogData.size) {
  //   form.querySelector(".js-sg-dont-know-weight").click();
  //   form.querySelector('.js-sg-dont-know-size[data-text="' + dogData.size + '"]').click();
  // }

  if (dogData.breed) {
    if (document.querySelectorAll('.js-sg-breed[data-value="' + dogData.breed.toLowerCase() + '"]').length > 0) {
      document.querySelector('.js-sg-breed[data-value="' + dogData.breed.toLowerCase() + '"]').click();
    } else {
      if (document.querySelector(".js-sg-breed-value").classList.contains("unselected")) {
        document.querySelector(".js-sg-breed-value").classList.remove("unselected");
      }

      document.querySelector(".js-sg-breed-value span").innerText = dogData.breed;
    }
  }

  if (document.querySelectorAll('.js-sg-eats-petzyo[value="' + dogData.eats_petzyo + '"]').length > 0) {
    document.querySelector('.js-sg-eats-petzyo[value="' + dogData.eats_petzyo + '"]').click();
  }

  // let formEatElem = document.querySelector('.js-sg-eats-petzyo[value="' + dogData.eats_petzyo + '"]');
  // if (formEatElem) {
  //   let formEat = formEatElem.closest(".sg-radio");
  //   if (formEat) {
  //     if (dogData.diet_ratio && document.querySelectorAll('.js-sg-diet-ratio[data-value="' + dogData.diet_ratio + '"]').length > 0) {
  //       document.querySelector('.js-sg-diet-ratio[data-value="' + dogData.diet_ratio + '"]').click();
  //     }
  //   }
  // }

  if (dogData.diet_ratio && dogData.diet_ratio < 1) {
    if (document.querySelectorAll('.js-sg-diet-ratio[data-value="' + dogData.diet_ratio + '"]').length > 0) {
      document.querySelector('.js-sg-diet-ratio[data-value="' + dogData.diet_ratio + '"]').click();
    }
  }

  if (dogData.eats_petzyo) {
    if (dogData.petzyo_flavour) {
      let petzyoFlavour = dogData.petzyo_flavour.toLowerCase();
      if (document.querySelectorAll('.js-sg-petzyo-flavour[data-value="' + petzyoFlavour + '"]').length > 0) {
        document.querySelector('.js-sg-petzyo-flavour[data-value="' + petzyoFlavour + '"]').click();
      }
    }
  } else {
    // if (dogData.other_flavour) {
    //   let otherFlavour = dogData.other_flavour.toLowerCase();
    //   if (document.querySelectorAll('.js-sg-other-product[data-value="' + otherFlavour + '"]').length > 0) {
    //     document.querySelector('.js-sg-other-product[data-value="' + otherFlavour + '"]').click();
    //   }
    // }
    // if (dogData.other_me) {
    //   if (document.querySelectorAll(".js-sg-other-me").length > 0) {
    //     document.querySelector(".js-sg-other-me").value = dogData.other_me;
    //   }
    // }
  }

  checkValidateSgForm();
  checkEatPetzyo();

  let elem = document.querySelector(".sg-step-2");

  setAttributes(elem, { "data-choose": true, "data-status": "choose", "data-dog-name": dogData.name });

  document.body.classList.remove("sg-popup--opening");
  document.querySelector(".sg-popup").setAttribute("data-popup", "");

  pageLoad(false);
}

function checkValidateSgForm() {
  let // form = document.querySelector(".sg-tab-content.active"),
    // dataForm = form.getAttribute("data-form"),
    dogName = document.querySelector(".js-sg-name").value,
    // weight = "",
    // targetWeight = "",
    isEatPetzyo = document.querySelector(".sg-cf-field-diet .sg-radio.selected .js-sg-eats-petzyo").value,
    isMix = document.querySelector(".sg-cf-field-mix .sg-radio.selected .js-sg-food-mix").value,
    productMeDiet = "kcal per kg",
    productMeMix = "kcal per kg",
    buttonNext = document.querySelector(".js-sg-next-btn"),
    buttonPrev = document.querySelector(".js-sg-prev-btn"),
    buttonSubmit = document.querySelector(".js-sg-calculate"),
    productNewDiet = "1",
    productNewMix = "1";

  if (isEatPetzyo == false || isEatPetzyo == "false") {
    productMeDiet = document.querySelector('input[name="dogs_diet_other_me"]').value;
    if (document.querySelector(".sg-radio-eats-other .sg-other-brand-wrap").classList.contains("more-new-brands")) {
      productNewDiet = document.querySelector(".sg-radio-eats-other .js-sg-other-new-product").value;
    }
  }

  if (isMix == true || isMix == "true") {
    productMeMix = document.querySelector('input[name="dogs_mix_other_me"]').value;
    if (document.querySelector(".sg-radio-food-mix .sg-other-brand-wrap").classList.contains("more-new-brands")) {
      productNewMix = document.querySelector(".sg-radio-food-mix .js-sg-other-new-product").value;
    }
  }

  if (dogName != "") {
    buttonNext.disabled = false;
    if (productMeDiet != "" && productNewDiet != "" && productMeMix != "" && productNewMix != "") {
      buttonSubmit.disabled = false;
    } else {
      buttonSubmit.disabled = true;
    }
  } else {
    buttonNext.disabled = true;
    buttonSubmit.disabled = true;
  }
}

function checkEatPetzyo() {
  let isEatPetzyo = document.querySelector(".sg-cf-field-diet .sg-radio.selected .js-sg-eats-petzyo").value;

  document.querySelector(".sg-step-2").setAttribute("data-petzyo", isEatPetzyo);
}

function sgFormNextStep() {
  if (document.querySelectorAll(".js-sg-next-btn").length) {
    document.querySelectorAll(".js-sg-next-btn").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (btn.classList.contains('js-add-new-breed')) {
          newBreedToKlaviyo();
        }
        document.querySelector(".sg-form-initial").classList.add("form-step-2-active");

        // Enable Previous step button when moving to step 2
        const prevBtn = document.querySelector(".js-sg-prev-btn");
        if (prevBtn) {
          prevBtn.disabled = false;
        }
      });
    });
  }

  // Handle Previous step button click
  if (document.querySelectorAll(".js-sg-prev-btn").length) {
    document.querySelectorAll(".js-sg-prev-btn").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        // Remove step 2 active class to go back to step 1
        document.querySelector(".sg-form-initial").classList.remove("form-step-2-active");

        // Disable Previous step button when back to step 1
        btn.disabled = true;
      });
    });
  }
}

async function newBreedToKlaviyo() {
  let publicKey = "K7Vvzk";
  if (window.shopUrl.includes("dev")) {
    publicKey = "Wbv8q9";
  }

  const options = {
    method: "POST",
    headers: { accept: "text/html", "content-type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({
      data:
        '{"token": "' +
        publicKey +
        '", "event": "Someone has added a new breed", "customer_properties": {"$email": "' +
        window.newBreed.email +
        '"}, "properties": {"SG_new_breed": "' +
        window.newBreed.breed +
        '"}}',
    }),
  };

  fetch("https://a.klaviyo.com/api/track", options)
    .then((response) => response.json())
    .then((response) => console.log(response))
    .catch((err) => console.error(err));
}

function sgCalculate() {
  if (document.querySelectorAll(".js-sg-calculate").length) {
    document.querySelectorAll(".js-sg-calculate").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        pageLoad(true);

        let form = document.querySelector(".sg-tab-content.active"),
          isEatPetzyo = document.querySelector(".sg-cf-field-diet .sg-radio.selected .js-sg-eats-petzyo").value,
          isMix = document.querySelector(".sg-cf-field-mix .sg-radio.selected .js-sg-food-mix").value,
          dogEat,
          dataProduct = document.querySelector(".js-sg-recommend-data"),
          dataProductMix = document.querySelector(".js-sg-recommend-data"),
          dataMixFood,
          dataForm = form.getAttribute("data-form"),
          dogName = document.querySelector(".js-sg-name").value,
          dogBreed = "Unknown Cute floof",
          lifestage = form.getAttribute("data-lifestage"),
          isAdult,
          weight,
          targetWeight,
          activityLevel,
          bodyshape,
          dietRatio,
          otherBrand,
          otherProduct,
          otherMe,
          otherFood,
          puppyAge,
          dogWeightKnown,
          weightRange,
          puppyTargetWeight = "",
          dietDensity = "", dietDate = "", dietSource = "",
          dietBrandProduct = "", mixBrandProduct = "",
          mixOtherBrand,
          mixProduct,
          mixOtherMe,
          mixOtherFood,
          mixDensity = "", mixDate = "", mixSource = "",
          mixBrandDiff = false,
          info = {},
          sgDogsField = [],
          sgDietInfo = {},
          sgMixInfo = {},
          sgDiet = [],
          sgPetzyoDietInfo = {},
          sgPetzyoMixInfo = {},
          sgPetzyoDiet = [],
          timesUsedPetzyo = 0;

        if (dataForm == "adult") {
          isAdult = true;
          let weightWrap = form.querySelector(".sg-cf-weight .sg-radio.selected");

          if (weightWrap.getAttribute("data-know") === "true") {
            dogWeightKnown = true;
            weight = parseInt(weightWrap.querySelector(".js-sg-weight.active").getAttribute("data-value"), 10);
          } else {
            dogWeightKnown = false;
            weightRange = weightWrap.querySelector(".js-sg-select-value.active").getAttribute("data-text");

            weight = parseFloat(weightWrap.querySelector(".js-sg-select-value.active").getAttribute("data-value"));
          }

          activityLevel = form.querySelector(".js-sg-activity-level:checked").value;
          bodyshape = form.querySelector(".js-sg-bodyshape.active").getAttribute("data-value");
          info["bodyshape"] = bodyshape;
        } else {
          isAdult = false;
          weight = parseInt(form.querySelector(".js-sg-weight.active").getAttribute("data-value"), 10);

          let targetWeightWrap = form.querySelector(".sg-cf-weight .sg-radio.selected");
          if (targetWeightWrap.getAttribute("data-know") === "true") {
            dogWeightKnown = true;
            targetWeight = parseInt(targetWeightWrap.querySelector(".js-sg-target-weight.active").getAttribute("data-value"), 10);
          } else {
            dogWeightKnown = false;
            weightRange = targetWeightWrap.querySelector(".js-sg-select-value.active").getAttribute("data-text");

            targetWeight = parseFloat(targetWeightWrap.querySelector(".js-sg-select-value.active").getAttribute("data-value"));
            puppyTargetWeight = targetWeightWrap.querySelector(".js-sg-select-value.active").getAttribute("data-text");
          }

          puppyAge = form.querySelector(".js-puppy-age-serving.active").getAttribute("data-value");

          info["puppy_age"] = puppyAge;
        }

        if (isMix == true || isMix == "true") {
          mixRatio = parseFloat(document.querySelector(".js-sg-diet-ratio.active").getAttribute("data-value"));
          dietRatio = 1 - mixRatio;
          let checkMixNewBrand = document.querySelector(".sg-radio-food-mix .sg-other-brand-wrap").classList.contains("more-new-brands");

          if (checkMixNewBrand && document.querySelectorAll(".sg-radio-food-mix .js-sg-mix-other-brand > span").length > 0) {
            mixOtherBrand = document.querySelector(".sg-radio-food-mix .js-sg-mix-other-brand > span").innerText;
          } else if (document.querySelectorAll(".sg-radio-food-mix .js-sg-brand.active").length > 0) {
            mixOtherBrand = document.querySelector(".sg-radio-food-mix .js-sg-brand.active").getAttribute("data-value");
          }

          if (checkMixNewBrand && document.querySelectorAll(".sg-radio-food-mix .js-sg-other-new-product").length > 0) {
            mixProduct = document.querySelector(".sg-radio-food-mix .js-sg-other-new-product").value;
          } else if (document.querySelectorAll(".sg-radio-food-mix .js-sg-other-product.active").length > 0) {
            let mixSelectProduct = document.querySelector(".sg-radio-food-mix .js-sg-other-product.active");
            mixProduct = mixSelectProduct.getAttribute("data-value");
            mixDensity = mixSelectProduct.getAttribute("data-density");
            mixDate = mixSelectProduct.getAttribute("data-date");
            mixSource = mixSelectProduct.getAttribute("data-source");
          }

          if (document.querySelectorAll(".sg-radio-food-mix .js-sg-other-me").length > 0) {
            mixOtherMe = parseInt(document.querySelector(".sg-radio-food-mix .js-sg-other-me").value, 10);
          }
          if (document.querySelectorAll(".sg-radio-food-mix .js-sg-other-tof.active").length > 0) {
            mixOtherFood = document.querySelector(".sg-radio-food-mix .js-sg-other-tof.active").getAttribute("data-value");
          }

          if (checkMixNewBrand) {
            dataMixFood = document.querySelector(".sg-radio-food-mix .js-sg-other-tof.active").getAttribute("data-tof-handle");
            if (document.querySelectorAll('.js-sg-recommend-data[data-recommend="' + dataMixFood + '"]').length > 0) {
              dataProductMix = document.querySelector('.js-sg-recommend-data[data-recommend="' + dataMixFood + '"]');
            }
          } else {
            let dataProductIdMix = document.querySelector(".sg-radio-food-mix .js-sg-other-product.active").getAttribute("data-recommend");
            if (document.querySelectorAll('.js-sg-recommend-data[data-id="' + dataProductIdMix + '"]').length > 0) {
              dataProductMix = document.querySelector('.js-sg-recommend-data[data-id="' + dataProductIdMix + '"]');
            }
          }

          mixBrandProduct = mixOtherBrand.trim().toLowerCase() + ' === ' + mixProduct.trim().toLowerCase();
        } else {
          dietRatio = 1;
        }

        if (isEatPetzyo == true || isEatPetzyo == "true") {
          dogEat = document.querySelector(".sg-cf-field-diet .js-sg-petzyo-flavour.active").getAttribute("data-value");
          let dataProductId = document.querySelector(".sg-cf-field-diet .js-sg-petzyo-flavour.active").getAttribute("data-recommend");
          if (document.querySelectorAll('.js-sg-recommend-data[data-id="' + dataProductId + '"]').length > 0) {
            dataProduct = document.querySelector('.js-sg-recommend-data[data-id="' + dataProductId + '"]');
          }

          dietBrandProduct = "petzyo === " + document.querySelector(".sg-cf-field-diet .js-sg-petzyo-flavour.active").innerText.trim().toLowerCase();
          if (isMix == true || isMix == "true") {
            if (dietBrandProduct == mixBrandProduct) {
              dietRatio = 1;
            }
          }

          sgDietInfo["foodType"] = "PETZYO_SINGLE";
          sgDietInfo["dietPercent"] = dietRatio;
          sgDietInfo["extraProps"] = {
            dataProduct: dataProduct.getAttribute('data-id'),
            productTitle: dataProduct.querySelector(".sg-recommend-product").getAttribute("data-product-title"),
            kcalPerBag: document.querySelector(".sg-cf-field-diet .js-sg-petzyo-flavour.active").getAttribute("data-kcal-bag"),
          };
          sgDietInfo["food"] = {
            id: dataProduct.querySelector(".sg-recommend-product").getAttribute("data-product-id"),
            qty: 1,
          };
          sgDiet.push(sgDietInfo);

          products.push({
            id: dataProduct.querySelector(".sg-recommend-product").getAttribute("data-product-id"),
            qty: 1,
          });
          timesUsedPetzyo += 1;
        } else {
          dogEat = document.querySelector(".sg-radio-eats-other .js-sg-other-product.active").getAttribute("data-value");

          let checkDietNewBrand = document.querySelector(".sg-radio-eats-other .sg-other-brand-wrap").classList.contains("more-new-brands");
          if (checkDietNewBrand && document.querySelectorAll(".sg-radio-eats-other .js-sg-diet-other-brand > span").length > 0) {
            otherBrand = document.querySelector(".sg-radio-eats-other .js-sg-diet-other-brand > span").innerText;
          } else if (document.querySelectorAll(".sg-radio-eats-other .js-sg-brand.active").length > 0) {
            otherBrand = document.querySelector(".sg-radio-eats-other .js-sg-brand.active").getAttribute("data-value");
          }

          if (checkDietNewBrand && document.querySelectorAll(".sg-radio-eats-other .js-sg-other-new-product").length > 0) {
            otherProduct = document.querySelector(".sg-radio-eats-other .js-sg-other-new-product").value;
          } else if (document.querySelectorAll(".sg-radio-eats-other .js-sg-other-product.active").length > 0) {
            let dietSelectProduct = document.querySelector(".sg-radio-eats-other .js-sg-other-product.active");
            otherProduct = dietSelectProduct.getAttribute("data-value");

            dietDensity = dietSelectProduct.getAttribute("data-density");
            dietDate = dietSelectProduct.getAttribute("data-date");
            dietSource = dietSelectProduct.getAttribute("data-source");
          }

          dietBrandProduct = otherBrand.trim().toLowerCase() + " === " + otherProduct.trim().toLowerCase();
          if (isMix == true || isMix == "true") {
            if (dietBrandProduct == mixBrandProduct) {
              dietRatio = 1;
            }
          }

          if (document.querySelectorAll(".sg-radio-eats-other .js-sg-other-me").length > 0) {
            otherMe = parseInt(document.querySelector(".sg-radio-eats-other .js-sg-other-me").value, 10);
          }

          if (document.querySelectorAll(".sg-radio-eats-other .js-sg-other-tof.active").length > 0) {
            otherFood = document.querySelector(".sg-radio-eats-other .js-sg-other-tof.active").getAttribute("data-value");
          }

          if (checkDietNewBrand) {
            let dataDietFood = document.querySelector(".sg-radio-eats-other .js-sg-other-tof.active").getAttribute("data-tof-handle");
            if (document.querySelectorAll('.js-sg-recommend-data[data-recommend="' + dataDietFood + '"]').length > 0) {
              dataProduct = document.querySelector('.js-sg-recommend-data[data-recommend="' + dataDietFood + '"]');
            }
          } else {
            let dataProductIdDiet = document.querySelector(".sg-radio-eats-other .js-sg-other-product.active").getAttribute("data-recommend");
            if (document.querySelectorAll('.js-sg-recommend-data[data-id="' + dataProductIdDiet + '"]').length > 0) {
              dataProduct = document.querySelector('.js-sg-recommend-data[data-id="' + dataProductIdDiet + '"]');
            }
          }

          if (mixOtherBrand != "petzyo") {
            mixBrandDiff = true;
          }

          sgDietInfo["foodType"] = "CUSTOM";
          sgDietInfo["dietPercent"] = dietRatio;
          sgDietInfo["food"] = {
            id: "custom-1",
            qty: 1,
            recipe: {
              type: otherFood,
              kcal: otherMe,
            },
          };
          sgDietInfo["extraProps"] = {
            brand: otherBrand,
            flavour: otherProduct,
            density: dietDensity,
            date: dietDate,
            source: dietSource,
            dataProduct: dataProduct.getAttribute('data-id'),
            tof: otherFood,
          };

          sgDiet.push(sgDietInfo);

          if (mixOtherBrand == "petzyo") {
            dataProduct = dataProductMix;
          }

          // Convert to petzyo product to display product recommendation
          sgPetzyoDietInfo["foodType"] = "PETZYO_SINGLE";
          sgPetzyoDietInfo["dietPercent"] = dietRatio;
          sgPetzyoDietInfo["extraProps"] = {
            dataProduct: dataProduct.getAttribute('data-id'),
            productTitle: dataProduct.querySelector(".sg-recommend-product").getAttribute("data-product-title"),
          };
          sgPetzyoDietInfo["food"] = {
            id: dataProduct.querySelector(".sg-recommend-product").getAttribute("data-product-id"),
            qty: 1,
          };
          sgPetzyoDiet.push(sgPetzyoDietInfo);
        }

        dataProduct.querySelector(".sg-recommend-product").classList.add("active");

        info["diet_ratio"] = dietRatio;
        info["name"] = dogName;
        info["is_adult"] = isAdult;
        info["activity_level"] = activityLevel;
        info["weight"] = weight;
        info["target_weight"] = targetWeight;
        info["lifestage"] = lifestage;

        if (document.querySelectorAll(".js-sg-breed.active").length > 0) {
          dogBreed = document.querySelector(".js-sg-breed.active").getAttribute("data-value");
        }

        info["dog_breed"] = dogBreed;

        // Compare 2 products are similar or not
        if (isMix == true || isMix == "true") {
          if (mixBrandProduct != dietBrandProduct) {
            if (mixOtherBrand == "petzyo") {
              sgMixInfo["foodType"] = "PETZYO_SINGLE";
              sgMixInfo["dietPercent"] = mixRatio;
              sgMixInfo["extraProps"] = {
                dataProduct: dataProductMix.getAttribute('data-id'),
                productTitle: dataProductMix.querySelector(".sg-recommend-product").getAttribute("data-product-title"),
                kcalPerBag: document.querySelector(".sg-radio-food-mix .js-sg-other-product.active").getAttribute("data-kcal-bag"),
              };
              sgMixInfo["food"] = {
                id: dataProductMix.querySelector(".sg-recommend-product").getAttribute("data-product-id"),
                qty: 1,
              };
              sgDiet.push(sgMixInfo);

              timesUsedPetzyo += 1;
            } else {
              sgMixInfo["foodType"] = "CUSTOM";
              sgMixInfo["dietPercent"] = mixRatio;
              sgMixInfo["food"] = {
                id: "custom-2",
                qty: 1,
                recipe: {
                  type: mixOtherFood,
                  kcal: mixOtherMe,
                },
              };
              sgMixInfo["extraProps"] = {
                brand: mixOtherBrand,
                flavour: mixProduct,
                density: mixDensity,
                date: mixDate,
                source: mixSource,
                dataProduct: dataProductMix.getAttribute('data-id'),
                tof: mixOtherFood,
              };
              sgDiet.push(sgMixInfo);
            }

            // Convert other brand's products to petzyo products
            sgPetzyoMixInfo["foodType"] = "PETZYO_SINGLE";
            sgPetzyoMixInfo["dietPercent"] = mixRatio;
            sgPetzyoMixInfo["food"] = {
              id: dataProductMix.querySelector(".sg-recommend-product").getAttribute("data-product-id"),
              qty: 1,
            };
            sgPetzyoDiet.push(sgPetzyoMixInfo);
          }
        }

        dogsField.push(info);

        // sgDiet = sgDiet.reverse();
        // sgPetzyoDiet = sgPetzyoDiet.reverse();

        sgCalculateApi(
          sgDiet,
          dogsField,
          isAdult,
          isEatPetzyo,
          isMix,
          products[0],
          dataProduct.querySelector(".sg-recommend-product"),
          puppyTargetWeight,
          dogEat,
          otherMe,
          puppyAge,
          dogWeightKnown,
          weightRange,
          mixBrandDiff,
          sgPetzyoDiet,
          mixOtherBrand,
          mixProduct,
          timesUsedPetzyo
        );

        fillUpdatePopup(dogName, weight, targetWeight, activityLevel, dataForm, bodyshape);
      });
    });
  }
}

async function sgCalculateApi(
  sgDiet,
  dogsField,
  isAdult,
  isEatPetzyo,
  isMix,
  product,
  dataProduct,
  puppyTargetWeight,
  dogEat,
  otherMe,
  puppyAge,
  dogWeightKnown,
  weightRange,
  mixBrandDiff,
  sgPetzyoDiet,
  mixOtherBrand,
  mixProduct,
  timesUsedPetzyo
) {
  let productTitle = dataProduct.getAttribute("data-product-title");

  const servingApi = await fetch("https://staging.home.petzyo.com.au/api/petzyo/serving/single-guide-mixed", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      dogs: dogsField,
      diet: sgDiet,
    }),
  });
  let data = await servingApi.json();
  sgResultApi = data;

  // Render API result
  let serving_cards = data.serving_cards[0].serving.cards;
  let serving_card = data.serving_cards[0].serving.cards[0];
  let dataOriginal = data;

  let dogName = data.serving_cards[0].dog.name ? data.serving_cards[0].dog.name : "",
    day = 0,
    kcalPerDay = "",
    otherBrand = 0;

  data.recurrence.map(function (dataRecurrence) {
    const pr_id = dataRecurrence.id;
    serving_cards.map(function (serving) {
      if (pr_id === serving.id) {
        let portionInteger,
          portionFraction,
          portionNumerator,
          portionDenominator,
          portionHTML = "";
        if (serving.serving_label.indexOf(" ") > -1 || serving.serving_label.indexOf("/") > -1) {
          if (serving.serving_label.indexOf(" ") > -1) {
            portionInteger = serving.serving_label.split(" ")[0];
            portionFraction = serving.serving_label.split(" ")[1];
            portionHTML = portionInteger;
          } else {
            portionFraction = serving.serving_label;
          }
          if (serving.serving_label.indexOf("/") > -1) {
            portionNumerator = portionFraction.split("/")[0];
            portionDenominator = portionFraction.split("/")[1];
            portionHTML = portionHTML + "<span><sup>" + portionNumerator + "</sup><span>" + portionDenominator + "</span></span>";
          }
        } else {
          portionHTML = serving.serving_label;
        }

        if (pr_id.indexOf("custom") > -1) {
          // Another brand
          let source = serving.extraProps.source;
          let note = `*The serving guide assumes a product density of ${serving.extraProps.density} g/L and a metabolisable energy of ${serving.kcal} kcal/kg (Last updated: ${serving.extraProps.date})`;

          if (source != "") {
            note = `*The serving guide assumes a product density of ${serving.extraProps.density} g/L and a metabolisable energy of ${serving.kcal} kcal/kg (Last updated: ${serving.extraProps.date} from source: ${serving.extraProps.source})`;
          }
          let productTof = serving.extraProps.tof.toLowerCase().trim().replaceAll(" ", "-");
          let unitPortionHtml = `
            <p class="serving-grams-only"><span class="js-sg-grams">${Math.round(serving.serving_grams)}</span> grams</p>
          `;

          if (productTof == 'dry' || productTof == 'freeze-dried' || productTof == 'air-dried') {
            unitPortionHtml = `
              <p class="sg-result-bold sg-adult-portion">
                <span class="sg-portion js-sg-adult-portion">
                  ${portionHTML}
                </span>
                <span class="js-sg-adult-unit">${serving.serving_unit}*</span>
              </p>
              <p><span class="js-sg-grams">${Math.round(serving.serving_grams)}</span> grams</p>
            `;
          }

          let html = `
            <div class="sg-recommend-block sg-guide-block">
              <div class="sg-guide-info">
                <div class="sg-recommend-info-header">
                  <p class="sg-recommend-info-heading">${serving.extraProps.brand} Guide</p>
                  <p>
                    <span class="js-sg-dog-name sg-dog-name">${data.serving_cards[0].dog.name}</span> will need <span class="js-kcal-per-day">${Math.round(serving.me_per_day)}</span> kcal per
                    day
                  </p>
                </div>
                
                <div class="sg-result-blocks">
                  <div class="sg-result-block">
                      <div class="sg-result-icon js-sg-unit-icon">
                        <img src="${window.assetIcon.iconCup}" loading="lazy" />
                      </div>
                      <div class="sg-result-text">
                        ${unitPortionHtml}
                      </div>
                    </div><div class="sg-result-block">
                      <div class="sg-result-icon">
                        <img src="${window.assetIcon.iconClock}" loading="lazy" />
                      </div>
                      <div class="sg-result-text">
                        <p class="sg-result-bold ">Split across</p>
                        <p>2 meals daily</p>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <p class="sg-guide-note">${note}</p>
          `;
          document.querySelector(".js-sg-recommend-block").insertAdjacentHTML("beforeend", html);
        } else {
          // Petzyo's product
          if (timesUsedPetzyo == 0 && document.querySelectorAll('.sg-recommend-heading').length == 0) {
            let headingHTML = `<p class="sg-recommend-heading">Our product recommendation</p>`;
            document.querySelector(".js-sg-recommend-block").insertAdjacentHTML("beforeend", headingHTML);
          }

          serving_card = serving;
          day = dataRecurrence.recurrence;

          let rebuyHtml = `
            <div class="sg-result-block js-sg-rebuy sg-result-block-rebuy">
              <div class="sg-result-icon">
                <img src="${window.assetIcon.iconFrequency}" loading="lazy" />
              </div>
              <div class="sg-result-text">
                <p class="sg-result-bold">Will last you</p>
                <p><span class="js-sg-day">${Math.round(dataRecurrence.recurrence)}</span> days</p>
              </div>
            </div>
          `;

          if (isPetstock == true || isPetstock == "true") {
            let kcalPerBag = serving_card.extraProps?.kcalPerBag;
            if (kcalPerBag && kcalPerBag != "" && !isNaN(parseFloat(kcalPerBag))) {
              rebuyHtml = `
                <div class="sg-result-block js-sg-rebuy sg-result-block-rebuy show-rebuy">
                  <div class="sg-result-icon">
                    <img src="${window.assetIcon.iconFrequency}" loading="lazy" />
                  </div>
                  <div class="sg-result-text">
                    <p class="sg-result-bold">Will last you</p>
                    <p><span class="js-sg-day">${Math.round(parseFloat(kcalPerBag) / serving_card.me_per_day)}</span> days</p>
                  </div>
                </div>
              `;
            }
          }

          let unitAsset = window.assetIcon.iconPattie;
          if (serving.serving_unit == "cups") {
            unitAsset = window.assetIcon.iconCup;
          }
          let dataPetzyoProduct = document.querySelector(".sg-recommend-product");
          let dataProductId = serving.extraProps?.dataProduct;
          if (document.querySelectorAll('.js-sg-recommend-data[data-id="' + dataProductId + '"]').length > 0) {
            dataPetzyoProduct = document.querySelector('.js-sg-recommend-data[data-id="' + dataProductId + '"] .sg-recommend-product');
          }
          let html = `
            <div class="sg-recommend-block sg-petzo-block-${timesUsedPetzyo}">
              <div class="sg-recommend-image">
                <img src="${dataPetzyoProduct.getAttribute("data-image")}" class="js-sg-recommend-image">
              </div>
              <div class="sg-recommend-info">
                <div class="sg-recommend-info-header">
                  <p class="sg-recommend-info-heading">Our guide</p>
                  <p>
                    <span class="js-sg-dog-name sg-dog-name">${data.serving_cards[0].dog.name}</span> will need <span class="js-kcal-per-day">${Math.round(serving.me_per_day)}</span> kcal per day
                  </p>
                </div>
                <div class="sg-result-block">
                  <div class="sg-result-icon js-sg-unit-icon">
                    <img src="${unitAsset}" loading="lazy">
                  </div>
                  <div class="sg-result-text">
                    <p class="sg-result-bold sg-adult-portion">
                      <span class="sg-portion js-sg-adult-portion">${portionHTML}</span>
                      <span class="js-sg-adult-unit">${serving.serving_unit}</span>
                    </p>
                    <p><span class="js-sg-grams">${Math.round(serving.serving_grams)}</span> grams</p>
                  </div>
                </div>
                <div class="sg-result-block">
                  <div class="sg-result-icon">
                    <img src="${window.assetIcon.iconClock}" loading="lazy" />
                  </div>
                  <div class="sg-result-text">
                    <p class="sg-result-bold">Split across</p>
                    <p>2 meals daily</p>
                  </div>
                </div>
                ${rebuyHtml}
              </div>
            </div>
          `;
          document.querySelector(".js-sg-recommend-block").insertAdjacentHTML("beforeend", html);
        }
      }
    });
  });

  // Call the API a second time to convert products from other brands to petzyo products
  if (mixBrandDiff) {
    const servingPetzyoApi = await fetch("https://staging.home.petzyo.com.au/api/petzyo/serving/single-guide-mixed", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        dogs: dogsField,
        diet: sgPetzyoDiet,
      }),
    });

    data = await servingPetzyoApi.json();
    serving_cards = data.serving_cards[0].serving.cards;
    serving_card = data.serving_cards[0].serving.cards[0];

    data.recurrence.map(function (dataRecurrence, index) {
      const pr_id = dataRecurrence.id;
      serving_cards.map(function (serving) {
        if (pr_id === serving.id) {
          let portionInteger,
            portionFraction,
            portionNumerator,
            portionDenominator,
            portionHTML = "";
          if (serving.serving_label.indexOf(" ") > -1) {
            portionInteger = serving.serving_label.split(" ")[0];
            portionFraction = serving.serving_label.split(" ")[1];
            portionHTML = portionInteger;
          } else {
            portionFraction = serving.serving_label;
          }
          if (serving.serving_label.indexOf("/") > -1) {
            portionNumerator = portionFraction.split("/")[0];
            portionDenominator = portionFraction.split("/")[1];
            portionHTML = portionHTML + "<span><sup>" + portionNumerator + "</sup><span>" + portionDenominator + "</span></span>";
          }

          // Petzyo's product
          if (index == 0 && document.querySelectorAll('.sg-recommend-heading').length == 0) {
            let headingHTML = `<p class="sg-recommend-heading">Our product recommendation</p>`;
            document.querySelector(".js-sg-recommend-block").insertAdjacentHTML("beforeend", headingHTML);
          }

          serving_card = serving;
          day = dataRecurrence.recurrence;

          let unitAsset = window.assetIcon.iconPattie;
          if (serving.serving_unit == "cups") {
            unitAsset = window.assetIcon.iconCup;
          }
          let dataPetzyoProduct = document.querySelector(".sg-recommend-product");
          let dataProductId = serving.extraProps.dataProduct;
          if (document.querySelectorAll('.js-sg-recommend-data[data-id="' + dataProductId + '"]').length > 0) {
            dataPetzyoProduct = document.querySelector('.js-sg-recommend-data[data-id="' + dataProductId + '"] .sg-recommend-product');
          }
          let html = `
            <div class="sg-recommend-block">
              <div class="sg-recommend-image">
                <img src="${dataPetzyoProduct.getAttribute("data-image")}" class="js-sg-recommend-image">
              </div>
              <div class="sg-recommend-info">
                <div class="sg-recommend-info-header">
                  <p class="sg-recommend-info-heading">Our guide</p>
                  <p>
                    <span class="js-sg-dog-name sg-dog-name">${data.serving_cards[0].dog.name}</span> will need <span class="js-kcal-per-day">${Math.round(serving.me_per_day)}</span> kcal per day
                  </p>
                </div>
                <div class="sg-result-block">
                  <div class="sg-result-icon js-sg-unit-icon">
                    <img src="${unitAsset}" loading="lazy">
                  </div>
                  <div class="sg-result-text">
                    <p class="sg-result-bold sg-adult-portion">
                      <span class="sg-portion js-sg-adult-portion">${portionHTML}</span>
                      <span class="js-sg-adult-unit">${serving.serving_unit}</span>
                    </p>
                    <p><span class="js-sg-grams">${Math.round(serving.serving_grams)}</span> grams</p>
                  </div>
                </div>
                <div class="sg-result-block">
                  <div class="sg-result-icon">
                    <img src="${window.assetIcon.iconClock}" loading="lazy" />
                  </div>
                  <div class="sg-result-text">
                    <p class="sg-result-bold">Split across</p>
                    <p>2 meals daily</p>
                  </div>
                </div>
                <div class="sg-result-block js-sg-rebuy sg-result-block-rebuy">
                  <div class="sg-result-icon">
                    <img src="${window.assetIcon.iconFrequency}" loading="lazy" />
                  </div>
                  <div class="sg-result-text">
                    <p class="sg-result-bold">Will last you</p>
                    <p><span class="js-sg-day">${Math.round(dataRecurrence.recurrence)}</span> days</p>
                  </div>
                </div>
              </div>
            </div>
          `;
          document.querySelector(".js-sg-recommend-block").insertAdjacentHTML("beforeend", html);
        }
      });
    });
  }

  // Check condition to show result
  let isVerified = document.querySelector(".sg-step-2").getAttribute("data-verify"),
    isChooseDog = document.querySelector(".sg-step-2").getAttribute("data-choose");
  document.querySelector(".page-serving-guide").classList.add("sg-adult-" + isAdult);

  // pageLoad(false);

  if (day == 0) {
    day = 28;
  }

  // Old smartLinkKlaviyo
  // "https://petzyo.com.au/apps/rebuy/cart?variants%5Bsg_variant_id%5D%5Bproperties%5D%5Bdog_fields%5D=%5B%7B%22activity_level%22:%22sg_activity_level%22,%22is_adult%22:sg_is_adult,%22name%22:%22sg_dog_name%22,%22target_weight%22:sg_target_weight,%22weight%22:sg_weight,%22products%22:%5B%7B%22id%22:sg_product_id,%22qty%22:1%7D%5D%7D%5D&variants%5Bsg_variant_id%5D%5Bproperties%5D%5Bnumber_charges_until_expiration%5D=&variants%5Bsg_variant_id%5D%5Bproperties%5D%5Bplan%5D=petzyo_plan&variants%5Bsg_variant_id%5D%5Bproperties%5D%5Bshipping_interval_frequency%5D=sg_recurrence&variants%5Bsg_variant_id%5D%5Bproperties%5D%5Bshipping_interval_unit_type%5D=day&variants%5Bsg_variant_id%5D%5Bproperties%5D%5BsubscriptionProd%5D=subscription%20product&variants%5Bsg_variant_id%5D%5Bproperties%5D%5Brecurrence_overrides%5D=sg_product_id:sg_recurrence&variants%5Bsg_variant_id%5D%5Bproperties%5D%5B_is_frequency%5D=true&variants%5Bsg_variant_id%5D%5Bquantity%5D=1&clear_cart=yes&discount=20off&landing_page=recharge_checkout&smart_cart_show=no",
  let smartLinkKlaviyo =
    window.shopUrl +
    "/apps/rebuy/cart?variants%5Bsg_variant_id%5D%5Bproperties%5D%5B_charge_interval_frequency%5D=sg_recurrence&variants%5Bsg_variant_id%5D%5Bproperties%5D%5B_is_frequency%5D=true&variants%5Bsg_variant_id%5D%5Bquantity%5D=1&variants%5Bsg_variant_id%5D%5Bselling_plan%5D=sg_selling_id&clear_cart=yes&landing_page=shopify_checkout&smart_cart_show=no",
    variantId = dataProduct.getAttribute("data-variant-id"),
    sellingId = dataProduct.parentNode.querySelector(".sg-product-selling-id").getAttribute("data-id");

  let week = 2;
  if (day >= 14) {
    week = Math.floor(day / 7);
  } else if (day >= 140) {
    week = 20;
  }

  let eleSelling = dataProduct.parentNode.querySelectorAll(".sg-product-selling-id[data-week='" + week + "']");
  if (eleSelling.length > 0) {
    sellingId = eleSelling[0].getAttribute("data-id");
  }

  smartLinkKlaviyo = smartLinkKlaviyo
    .replace(/sg_variant_id/g, variantId)
    .replace("sg_selling_id", sellingId)
    .replace("sg_recurrence", day);

  // .replace("sg_activity_level", dogActiveLevel)
  // .replace("sg_is_adult", data.serving_cards[0].dog.is_adult)
  // .replace("sg_is_adult", data.serving_cards[0].dog.is_adult)
  // .replace("sg_dog_name", data.serving_cards[0].dog.name)
  // .replace("sg_target_weight", dogTarget)
  // .replace("sg_weight", data.serving_cards[0].dog.weight)
  // .replace(/sg_product_id/g, productId)

  if (isVerified == false || isVerified == "false") {
    if (isEatPetzyo == false || isEatPetzyo == "false") {
      shortenUrl(smartLinkKlaviyo);
    }
  }

  updateRecommendProduct(dogName, dataProduct, smartLinkKlaviyo);

  // Show recommendation by Breed
  let productHandle = dataProduct.getAttribute("data-handle");
  let isSameBreed = false;
  if (document.querySelectorAll(".js-sg-breed.active").length > 0) {
    let dogBreed = document.querySelector(".js-sg-breed.active").getAttribute("data-handle");
    if (document.querySelectorAll('.js-data-breed[data-handle="' + dogBreed + '"]').length > 0) {
      let productHandleCheck = document.querySelector('.js-data-breed[data-handle="' + dogBreed + '"]').getAttribute("data-product");
      if (productHandleCheck == productHandle) {
        isSameBreed = true;
      }
    }
  }

  if (timesUsedPetzyo >= 1) {
    if (isMix == true || isMix == "true") {
      if (document.querySelectorAll(".sg-account-section").length > 0) {
        document.querySelector(".sg-account-section").style.display = "block";
      }
      nextStep();
      pageLoad(false);
    } else {
      callApiSectionProduct(dogName, productHandle, isSameBreed);
    }
  } else {
    if (document.querySelectorAll(".sg-recommend-title").length > 0) {
      document.querySelector(".sg-recommend-title").innerHTML = "Your doggo’s serving guide for their current food";
    }
    callApiSectionProduct(dogName, productHandle, isSameBreed);
  }

  // Update form data to DB
  // Round me_per_day values before saving
  const roundedServingCards = serving_cards.map(card => ({
    ...card,
    me_per_day: Math.round(card.me_per_day)
  }));
  servingGuide = roundedServingCards;
  recurrence = data.recurrence;

  // update dog info to database
  let sourceKey = "shopfront-serving-guide";
  if (isPetstock == true || isPetstock == "true") {
    sourceKey = "shopfront-serving-guide-petstock";
  }

  // Round me_per_day in dataOriginal before saving to DB
  const roundedOriginalCards = dataOriginal.serving_cards[0].serving.cards.map(card => ({
    ...card,
    me_per_day: Math.round(card.me_per_day)
  }));

  const payloadForm = JSON.stringify({
    id: getCookie("_ruid"),
    servingGuide: {
      dog: dogsField,
      product: product,
      servingGuide: roundedOriginalCards,
      recurrence: dataOriginal.recurrence,
    },
    sourceKey: sourceKey,
    sourceUrl: window.location.href,
  });

  const dbForm = await fetch("https://home.petzyo.com.au/api/storefront/serving-guide-form", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: payloadForm,
  });

  const dbFormResponse = await dbForm.json();

  // Fill information in klaviyo form
  if (document.querySelectorAll("#email_serving_guide").length > 0) {
    document.querySelector('#email_serving_guide input[name="SG_dog_name"]').value = dogName;
    document.querySelector('#email_serving_guide input[name="SG_dog_lifestage"]').value = data.serving_cards[0].dog.lifestage
      ? data.serving_cards[0].dog.lifestage
      : "";
    document.querySelector('#email_serving_guide input[name="SG_dog_weight"]').value = data.serving_cards[0].dog.weight ? data.serving_cards[0].dog.weight : "";
    document.querySelector('#email_serving_guide input[name="SG_is_adult"]').value = data.serving_cards[0].dog.is_adult
      ? data.serving_cards[0].dog.is_adult
      : "";
    document.querySelector('#email_serving_guide input[name="SG_bodyshape"]').value = data.serving_cards[0].dog.bodyshape
      ? data.serving_cards[0].dog.bodyshape
      : "";
    document.querySelector('#email_serving_guide input[name="SG_puppyweight"]').value = data.serving_cards[0].dog.target_weight
      ? data.serving_cards[0].dog.target_weight
      : "";
    document.querySelector('#email_serving_guide input[name="SG_diet_ratio"]').value = data.serving_cards[0].dog.diet_ratio
      ? data.serving_cards[0].dog.diet_ratio
      : "";
    document.querySelector('#email_serving_guide input[name="SG_serving_label"]').value = serving_card.serving_label ? serving_card.serving_label : "";
    document.querySelector('#email_serving_guide input[name="SG_eats_petzyo"]').value = isEatPetzyo ? isEatPetzyo : "";

    if (isEatPetzyo == true || isEatPetzyo == "true") {
      document.querySelector('#email_serving_guide input[name="SG_petzyo_flavour"]').value = dogEat ? dogEat : "";
    } else {
      document.querySelector('#email_serving_guide input[name="SG_other_brand"]').value = sgDiet[0].extraProps.brand ? sgDiet[0].extraProps.brand : "Petzyo";
      document.querySelector('#email_serving_guide input[name="SG_other_flavour"]').value = sgDiet[0].extraProps.flavour ? sgDiet[0].extraProps.flavour : "";
      document.querySelector('#email_serving_guide input[name="SG_other_me"]').value = sgDiet[0].food.recipe.kcal ? sgDiet[0].food.recipe.kcal : "";
    }

    if (isAdult == false || isAdult == "false") {
      document.querySelector('#email_serving_guide input[name="SG_puppy_age_serving"]').value = puppyAge ? puppyAge : "";
    }

    document.querySelector('#email_serving_guide input[name="SG_grams_per_day"]').value = serving_card.serving_grams
      ? Math.floor(serving_card.serving_grams)
      : "";
    document.querySelector('#email_serving_guide input[name="SG_units"]').value = serving_card.serving_unit ? serving_card.serving_unit : "";
    document.querySelector('#email_serving_guide input[name="SG_product_name"]').value = productTitle ? productTitle : "";
    document.querySelector('#email_serving_guide input[name="SG_recurrence_period"]').value = data.recurrence[0].recurrence ? data.recurrence[0].recurrence : "";
    document.querySelector('#email_serving_guide input[name="SG_serving_portion"]').value = serving_card.serving_portion ? serving_card.serving_portion : "";
    document.querySelector('#email_serving_guide input[name="SG_recipe_density_ratio"]').value = serving_card.recipe_density_ratio
      ? serving_card.recipe_density_ratio
      : "";
    document.querySelector('#email_serving_guide input[name="SG_kcal"]').value = serving_card.kcal ? serving_card.kcal : "";
    document.querySelector('#email_serving_guide input[name="SG_me_per_day"]').value = serving_card.me_per_day ? Math.round(serving_card.me_per_day) : "";
    document.querySelector('#email_serving_guide input[name="SG_dog_weight_known"]').value = dogWeightKnown ? dogWeightKnown : "";
    document.querySelector('#email_serving_guide input[name="SG_weight_range"]').value = weightRange ? weightRange : "";
  }
}

function fillUpdatePopup(dogName, weight, targetWeight, activityLevel, dataForm, bodyshape) {
  document.querySelector(".js-update-dog-name").innerText = dogName;
  document.querySelector(".js-update-dog-weight").innerText = weight;
  document.querySelector(".js-update-dog-activity-level").innerText = activityLevel;
  document.querySelector(".js-update-dog-lifestage").innerText = dataForm;

  if (dataForm == "adult") {
    document.querySelector(".js-update-dog-shape").innerText = bodyshape;
    document.querySelector(".js-update-dog-shape").parentNode.style.display = "block";
  } else {
    document.querySelector(".js-update-dog-target-weight").innerText = targetWeight;
    document.querySelector(".js-update-dog-target-weight").parentNode.style.display = "block";
  }
}

function convertToFraction(resultPortionWrap, portionInteger, portionFraction) {
  let numerator,
    denominator,
    isFraction = true,
    mixedNumbers,
    portionHTML = "";

  if (portionFraction <= 0.07) {
    isFraction = false;
  } else if (portionFraction >= 0.08 && portionFraction <= 0.13) {
    numerator = 1;
    denominator = 8;
  } else if (portionFraction >= 0.14 && portionFraction <= 0.17) {
    numerator = 1;
    denominator = 6;
  } else if (portionFraction >= 0.18 && portionFraction <= 0.2) {
    numerator = 1;
    denominator = 5;
  } else if (portionFraction >= 0.21 && portionFraction <= 0.25) {
    numerator = 1;
    denominator = 4;
  } else if (portionFraction >= 0.16 && portionFraction <= 0.33) {
    numerator = 1;
    denominator = 3;
  } else if (portionFraction >= 0.34 && portionFraction <= 0.4) {
    numerator = 2;
    denominator = 5;
  } else if (portionFraction >= 0.41 && portionFraction <= 0.5) {
    numerator = 1;
    denominator = 2;
  } else if (portionFraction >= 0.51 && portionFraction <= 0.6) {
    numerator = 3;
    denominator = 5;
  } else if (portionFraction >= 0.61 && portionFraction <= 0.66) {
    numerator = 2;
    denominator = 3;
  } else if (portionFraction >= 0.67 && portionFraction <= 0.75) {
    numerator = 3;
    denominator = 4;
  } else if (portionFraction >= 0.76 && portionFraction <= 0.8) {
    numerator = 4;
    denominator = 5;
  } else if (portionFraction >= 0.81 && portionFraction <= 0.88) {
    numerator = 7;
    denominator = 8;
  } else {
    isFraction = false;
    portionInteger = portionInteger + 1;
  }

  if (isFraction) {
    if (portionInteger == 0) {
      portionHTML = "<span><sup>" + numerator + "</sup><span>" + denominator + "</span></span>";
      mixedNumbers = numerator + "/" + denominator;
    } else {
      portionHTML = portionInteger + "<span><sup>" + numerator + "</sup><span>" + denominator + "</span></span>";
      mixedNumbers = portionInteger + " " + numerator + "/" + denominator;
    }
  } else {
    portionHTML = portionInteger;
    mixedNumbers = portionInteger;
  }

  if (resultPortionWrap.length) {
    resultPortionWrap.forEach((elm) => {
      elm.innerHTML = portionHTML;
    });
  }
}

async function shortenUrl(smartLinkKlaviyo) {
  const url = "https://url-shortener-service.p.rapidapi.com/shorten";
  const options = {
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "X-RapidAPI-Key": "ae1e45bdc5msha5e6923174987f6p1bac7cjsn6e7757c33574",
      "X-RapidAPI-Host": "url-shortener-service.p.rapidapi.com",
    },
    body: new URLSearchParams({
      url: smartLinkKlaviyo,
    }),
  };

  try {
    const response = await fetch(url, options);
    const result = await response.json();

    if (document.querySelectorAll("#email_serving_guide").length > 0) {
      document.querySelector('#email_serving_guide input[name="SG_permalink"]').value = result.result_url;
    }
  } catch (error) {
    console.error(error);
    if (document.querySelectorAll("#email_serving_guide").length > 0) {
      document.querySelector('#email_serving_guide input[name="SG_permalink"]').value = smartLinkKlaviyo;
    }
  }
}

function updateRecommendProduct(dogName, dataProduct, smartLink) {
  let variantId = dataProduct.getAttribute("data-variant-id"),
    productTitle = dataProduct.getAttribute("data-product-title");

  document.querySelectorAll(".js-sg-dog-name").forEach((elm) => {
    elm.innerText = dogName;
  });
  // document.querySelector(".js-kcal-per-day").innerText = kcalPerDay;
  if (document.querySelectorAll(".js-sg-recommend-title").length > 0) {
    document.querySelector(".js-sg-recommend-title").innerText = productTitle;
  }
  if (document.querySelectorAll(".js-sg-recommend-product-title").length > 0) {
    document.querySelector(".js-sg-recommend-product-title").innerText = dataProduct.getAttribute("data-weight") + "kg " + productTitle;
  }
  if (document.querySelectorAll(".js-sg-recommend-price").length > 0) {
    document.querySelector(".js-sg-recommend-price").innerText = dataProduct.getAttribute("data-price-subs");
  }
  if (document.querySelectorAll(".js-sg-add-recommend").length > 0) {
    if (dataProduct.getAttribute("data-type") == 'raw') {
      document.querySelector(".js-sg-add-recommend").innerText = 'Build a box';
      document.querySelector(".js-sg-add-recommend").classList.add('js-add-to-box');
      document.querySelector(".js-sg-add-recommend").setAttribute("data-type", "raw");
      document.querySelector(".js-sg-add-recommend").setAttribute("data-id", dataProduct.getAttribute("data-product-box"));
    } else {
      document.querySelector(".js-sg-add-recommend").innerText = 'Proceed to checkout';
      document.querySelector(".js-sg-add-recommend").setAttribute("data-url", smartLink);
      document.querySelector(".js-sg-add-recommend").setAttribute("data-type", "dry");
    }
  }
  // document.querySelector(".js-sg-recommend-image").setAttribute("src", dataProduct.getAttribute("data-image"));
  // document.querySelector(".js-sg-variant-recommend").value = variantId;
}

function callApiSectionProduct(dogName, productHandle, isSameBreed) {
  let url = "/products/" + productHandle + "?view=ajax-serving-guide";

  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      document.querySelector(".sg-recommend-section").innerHTML = responseText;
    })
    .finally(() => {
      nextStep();

      if (document.querySelectorAll(".js-ingredients-dog-name").length > 0) {
        document.querySelector(".js-ingredients-dog-name").innerText = dogName;
      }

      // let checkBreed = false;
      let breedName = "";

      if (document.querySelectorAll(".js-sg-breed.active").length > 0) {
        let dogBreed = document.querySelector(".js-sg-breed.active").getAttribute("data-handle");
        if (document.querySelectorAll('.js-data-breed[data-handle="' + dogBreed + '"]').length > 0) {
          let breedInfo = document.querySelector('.js-data-breed[data-handle="' + dogBreed + '"]');
          if (document.querySelectorAll('.sg-breed-section').length > 0) {
            let cloneBreedHtml = breedInfo.querySelector('.sg-breed-info-section').cloneNode(true);
            document.querySelector('.sg-breed-section').appendChild(cloneBreedHtml);
          }

          breedName = document.querySelector(".js-sg-breed.active").getAttribute("data-text");
          if (document.querySelectorAll('.js-ingredients-breed-name').length > 0) {
            document.querySelector('.js-ingredients-breed-name').innerText = breedName;
          }

          // checkBreed = true;
        }
      }

      if (document.querySelectorAll('.js-ingredients-breed-title').length > 0) {
        if (isSameBreed) {
          document.querySelector('.js-ingredients-breed-title').textContent = "Petzyo's Breed specific recommendation";
          if (document.querySelectorAll('.js-ingredients-breed-nutrition').length > 0) {
            let ingredientsText = document.querySelector('.js-ingredients-breed-nutrition').textContent;
            let ingredientsTextReplace = ingredientsText.replaceAll("===breed===", breedName);

            document.querySelector('.js-ingredients-breed-nutrition').textContent = ingredientsTextReplace;
            document.querySelector('.js-ingredients-breed-nutrition').style.display = "block";
          }
        } else {
          document.querySelector('.js-ingredients-breed-title').textContent = "A bit more detail about your formula selection";
          if (document.querySelectorAll('.js-ingredients-no-breed-nutrition').length > 0) {
            document.querySelector('.js-ingredients-no-breed-nutrition').style.display = "block";
          }
        }
      }

      if (document.querySelectorAll("sg-ingredients").length > 0) {
        setTimeout(() => {
          let ingredientsSlide = document.querySelector("sg-ingredients");
          let ingredientsFlkty = new Flickity(ingredientsSlide, {
            cellAlign: 'left',
            pageDots: false,
            adaptiveHeight: false,
            prevNextButtons: true,
            imagesLoaded: true,
            wrapAround: true
          });
          if (document.querySelectorAll('#SG-ingredients-previous').length > 0) {
            document.querySelector('#SG-ingredients-previous').addEventListener("click", () => {
              ingredientsFlkty.previous();
            });
          }
          if (document.querySelectorAll('#SG-ingredients-next').length > 0) {
            document.querySelector('#SG-ingredients-next').addEventListener("click", () => {
              ingredientsFlkty.next();
            });
          }
        }, 500);
      }

      if (window.innerWidth < 750) {
        if (document.querySelectorAll("slide-reviews").length > 0) {
          let reviewsSlide = document.querySelector("slide-reviews");
          let reviewsFlickity = new Flickity(reviewsSlide, {
            pageDots: true,
            adaptiveHeight: false,
            prevNextButtons: false,
            imagesLoaded: true,
            wrapAround: true,
          });
        }
      }

      pageLoad(false);
    });
}

function moveStickyBarToPageEnd() {
  const stickyBar = document.querySelector('.sg-recommend-sticky');
  const servingGuidePage = document.querySelector('.serving-guide-page');

  if (stickyBar && servingGuidePage) {
    servingGuidePage.appendChild(stickyBar);
    console.log('Sticky bar đã được di chuyển ra cuối .serving-guide-page');
  }
}

function nextStep() {
  document.querySelector(".js-sg-recommend").style.display = "block";
  document.querySelector(".page-serving-guide").classList.add("step-2");
  document.body.classList.add("serving-guide-step-2");
  document.querySelector(".sg-step-1").style.display = "none";
  document.querySelector(".sg-step-2").style.display = "block";
  window.scrollTo({ top: 0, behavior: "smooth" });

  moveStickyBarToPageEnd();
}

function handleUpdateDog() {
  document.querySelector(".js-update-dog-btn").addEventListener("click", (e) => {
    pageLoad(true);

    let isVerified = document.querySelector(".sg-step-2").getAttribute("data-verify"),
      isChooseDog = document.querySelector(".sg-step-2").getAttribute("data-choose");

    if (isChooseDog == true || isChooseDog == "true") {
      document.querySelector('.sg-popup-wrap[data-popup="update-dog"]').setAttribute("data-content", "selected");

      document.body.classList.add("sg-popup--opening");
      document.querySelector(".sg-popup").setAttribute("data-popup", "update-dog");
      pageLoad(false);
    } else {
      if (isVerified == false || isVerified == "false") {
        let mail = document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').getAttribute("data-mail");
        sendEmail(mail, true);
      } else {
        let mail = document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').getAttribute("data-mail"),
          dogName = document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').getAttribute("data-mail");
        checkCustomerData(mail, dogName, true);
      }
    }
  });

  let dogBtn = document.querySelectorAll(".js-sg-update-dog-btn, .js-sg-add-dog-btn");
  if (dogBtn.length) {
    dogBtn.forEach((btn) => {
      btn.addEventListener("click", () => {
        pageLoad(true);
        let type = btn.getAttribute("data-action");
        getDataUpdateDog(type);
      });
    });
  }
}

function getDataUpdateDog(type) {
  let form = document.querySelector(".sg-tab-content.active"),
    isEatPetzyo = form.querySelector(".sg-cf-field-diet .sg-radio.selected .js-sg-eats-petzyo").value,
    dogEat,
    dataForm = form.getAttribute("data-form"),
    dogName = document.querySelector(".js-sg-name").value,
    dogBreed = document.querySelector(".js-sg-breed-value span").innerText,
    isAdult,
    weight,
    targetWeight,
    activityLevel,
    bodyshape,
    ageServing,
    dietRatio,
    otherBrand,
    otherMe,
    info = {},
    dogsField = [];

  info["name"] = dogName;
  info["breed"] = dogBreed;

  if (dataForm == "adult") {
    isAdult = true;
    info["is_adult"] = isAdult;

    let weightWrap = form.querySelector(".sg-cf-weight .sg-radio.selected");
    if (weightWrap.getAttribute("data-know") == true || weightWrap.getAttribute("data-know") == "true") {
      weight = weightWrap.querySelector(".js-sg-weight.active").getAttribute("data-value");
      info["weight"] = weight;
    } else {
      weight = weightWrap.querySelector(".js-sg-select-value.active").innerText;
      info["size"] = weight;
    }

    bodyshape = form.querySelector(".js-sg-bodyshape.active").getAttribute("data-value");
    info["bodyshape"] = bodyshape;

    activityLevel = form.querySelector(".js-sg-activity-level:checked").value;
    info["activity_level"] = activityLevel;
  } else {
    isAdult = false;
    weight = parseInt(form.querySelector(".js-sg-weight.active").getAttribute("data-value"), 10);

    info["is_adult"] = isAdult;
    info["puppyweight"] = weight;

    let targetWeightWrap = form.querySelector(".sg-cf-weight .sg-radio.selected");
    if (weightWrap.getAttribute("data-know") == true || weightWrap.getAttribute("data-know") == "true") {
      targetWeight = parseInt(targetWeightWrap.querySelector(".js-sg-target-weight.active").getAttribute("data-value"), 10);
      info["target_weight"] = targetWeight;
    } else {
      targetWeight = targetWeightWrap.querySelector(".js-sg-select-value.active").innerText;
      info["size"] = targetWeight;
    }

    ageServing = document.querySelector(".js-puppy-age-serving.active").getAttribute("data-value");
    info["puppy_age_serving"] = ageServing;
  }

  info["eats_petzyo"] = isEatPetzyo;
  if (isEatPetzyo == true || isEatPetzyo == "true") {
    dogEat = document.querySelector(".js-sg-petzyo-flavour.active").getAttribute("data-value");
    info["petzyo_flavour"] = dogEat;

    dietRatio = document.querySelector(".sg-radio-eats-petzyo .js-sg-diet-ratio.active").getAttribute("data-value");
    info["diet_ratio"] = dietRatio;
  } else {
    dogEat = document.querySelector(".js-sg-other-product.active").getAttribute("data-value");
    info["other_flavour"] = dogEat;

    otherBrand = form.querySelector(".sg-radio-eats-other .js-sg-brand.active").getAttribute("data-value");
    if (otherBrand != "") {
      info["other_brand"] = otherBrand;
    }

    otherMe = form.querySelector(".sg-radio-eats-other .js-sg-other-me").value;
    if (otherMe != "") {
      info["other_me"] = otherMe;
    }

    // dietRatio = document.querySelector(".sg-radio-eats-other .js-sg-diet-ratio.active").getAttribute("data-value");
    // info["diet_ratio"] = dietRatio;
  }

  dogsField.push(info);

  apiUpdateDog(dogsField, type);
}

function apiUpdateDog(dogsField, type) {
  let mail = document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').getAttribute("data-mail"),
    dogName = "";

  if (type == "update") {
    dogName = document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').getAttribute("data-dog");
  }

  fetch("https://profileapp.petzyo.com.au/update-doggo", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      customerEmail: mail,
      dogNameBeforeUpdate: dogName,
      newDogInfo: dogsField[0],
    }),
  })
    .then((data) => {
      document.querySelector(".js-update-data-dog").style.display = "none";
      document.body.classList.remove("sg-popup--opening");
      document.querySelector(".sg-popup").setAttribute("data-popup", "");
      pageLoad(false);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function btnSmartLink() {
  document.querySelector(".js-sg-add-recommend").addEventListener("click", (e) => {
    pageLoad(true);
    let buttonType = e.currentTarget.getAttribute("data-type");

    if (buttonType == "raw") {
      localStorage.setItem("preAddBox", e.currentTarget.getAttribute('data-id'));
      window.location.href = window.buildBoxUrl;
    } else {
      let linkRedirect = e.currentTarget.getAttribute("data-url");
      window.location.href = linkRedirect;
    }
  });
}

function sgEmail() {
  document.querySelector(".js-show-sg-email-me").addEventListener("click", (e) => {
    document.querySelector(".js-sg-recommend").style.display = "none";
    document.querySelector(".sg-email").style.display = "block";
    window.scrollTo({ top: 0, behavior: "smooth" });
  });



  document.getElementById("email_serving_guide").addEventListener("submit", (e) => {
    e.preventDefault();
    pageLoad(true);

    let formData = e.target,
      customerEmail = formData.querySelector("#k_id_email").value;

    let SG_dog_name = formData.querySelector('input[name="SG_dog_name"]') ? formData.querySelector('input[name="SG_dog_name"]').value : "",
      SG_dog_lifestage = formData.querySelector('input[name="SG_dog_lifestage"]') ? formData.querySelector('input[name="SG_dog_lifestage"]').value : "",
      SG_dog_weight = formData.querySelector('input[name="SG_dog_weight"]') ? formData.querySelector('input[name="SG_dog_weight"]').value : "",
      SG_is_adult = formData.querySelector('input[name="SG_is_adult"]') ? formData.querySelector('input[name="SG_is_adult"]').value : "",
      SG_bodyshape = formData.querySelector('input[name="SG_bodyshape"]') ? formData.querySelector('input[name="SG_bodyshape"]').value : "",
      SG_puppyweight = formData.querySelector('input[name="SG_puppyweight"]') ? formData.querySelector('input[name="SG_puppyweight"]').value : "",
      SG_puppy_age_serving = formData.querySelector('input[name="SG_puppy_age_serving"]')
        ? formData.querySelector('input[name="SG_puppy_age_serving"]').value
        : "",
      SG_diet_ratio = formData.querySelector('input[name="SG_diet_ratio"]') ? formData.querySelector('input[name="SG_diet_ratio"]').value : "",
      SG_eats_petzyo = formData.querySelector('input[name="SG_eats_petzyo"]') ? formData.querySelector('input[name="SG_eats_petzyo"]').value : "",
      SG_weight_range = formData.querySelector('input[name="SG_weight_range"]') ? formData.querySelector('input[name="SG_weight_range"]').value : "",
      SG_petstock_page = formData.querySelector('input[name="SG_petstock_page"]') ? formData.querySelector('input[name="SG_petstock_page"]').value : "",
      SG_permalink = formData.querySelector('input[name="SG_permalink"]') ? formData.querySelector('input[name="SG_permalink"]').value : "";

    let propertiesOptions = {
      "SG_dog_name": SG_dog_name,
      "SG_dog_lifestage": SG_dog_lifestage,
      "SG_dog_weight": SG_dog_weight,
      "SG_is_adult": SG_is_adult,
      "SG_bodyshape": SG_bodyshape,
      "SG_puppyweight": SG_puppyweight,
      "SG_puppy_age_serving": SG_puppy_age_serving,
      "SG_diet_ratio": SG_diet_ratio,
      "SG_eats_petzyo": SG_eats_petzyo,
      "SG_weight_range": SG_weight_range,
      "SG_petstock_page": SG_petstock_page,
      "SG_permalink": SG_permalink,
    };

    let firstServingCards = sgResultApi.serving_cards[0].serving.cards[0];
    if (firstServingCards) {
      if (firstServingCards.id.indexOf("custom") > -1) {
        // Not Petzyo
        propertiesOptions["SG_other_brand1"] = firstServingCards.extraProps?.brand;
        propertiesOptions["SG_other_brand1_flavour"] = firstServingCards.extraProps?.flavour;
        propertiesOptions["SG_other_brand1_kcal"] = firstServingCards.kcal;
        propertiesOptions["SG_other_brand1_me_per_day"] = Math.round(firstServingCards.me_per_day);
        propertiesOptions["SG_other_brand1_serving_label"] = firstServingCards.serving_label;
        propertiesOptions["SG_other_brand1_grams_per_day"] = Math.round(firstServingCards.serving_grams);
        propertiesOptions["SG_other_brand1_source"] = firstServingCards.extraProps?.source;
      } else {
        // Eat Petzyo
        propertiesOptions["SG_product_name1"] = firstServingCards.extraProps?.productTitle;
        propertiesOptions["SG_kcal1"] = firstServingCards.kcal;
        propertiesOptions["SG_me_per_day1"] = Math.round(firstServingCards.me_per_day);
        propertiesOptions["SG_serving_label1"] = firstServingCards.serving_label;
        propertiesOptions["SG_grams_per_day1"] = Math.round(firstServingCards.serving_grams);
        propertiesOptions["SG_recurrence_period1"] = Math.round(sgResultApi.recurrence[0].recurrence);
      }
    }
    if (sgResultApi.serving_cards[0].serving.cards.length == 2) {
      let secondServingCards = sgResultApi.serving_cards[0].serving.cards[1];
      if (secondServingCards) {
        if (secondServingCards.id.indexOf("custom") > -1) {
          let i = 1;
          if (firstServingCards.id.indexOf("custom") > -1) {
            i = 2;
          }
          // Not Petzyo
          propertiesOptions["SG_other_brand" + i + ""] = secondServingCards.extraProps?.brand;
          propertiesOptions["SG_other_brand" + i + "_flavour"] = secondServingCards.extraProps?.flavour;
          propertiesOptions["SG_other_brand" + i + "_kcal"] = secondServingCards.kcal;
          propertiesOptions["SG_other_brand" + i + "_me_per_day"] = Math.round(secondServingCards.me_per_day);
          propertiesOptions["SG_other_brand" + i + "_serving_label"] = secondServingCards.serving_label;
          propertiesOptions["SG_other_brand" + i + "_grams_per_day"] = Math.round(secondServingCards.serving_grams);
          propertiesOptions["SG_other_brand" + i + "_source"] = secondServingCards.extraProps?.source;
        } else {
          // Mix Petzyo
          let i = 2;
          if (firstServingCards.id.indexOf("custom") > -1) {
            i = 1;
          }
          propertiesOptions["SG_product_name" + i + ""] = secondServingCards.extraProps?.productTitle;
          propertiesOptions["SG_kcal" + i + ""] = secondServingCards.kcal;
          propertiesOptions["SG_me_per_day" + i + ""] = Math.round(secondServingCards.me_per_day);
          propertiesOptions["SG_serving_label" + i + ""] = secondServingCards.serving_label;
          propertiesOptions["SG_grams_per_day" + i + ""] = Math.round(secondServingCards.serving_grams);
          propertiesOptions["SG_recurrence_period" + i + ""] = Math.round(sgResultApi.recurrence[1].recurrence);
        }
      }
    }

    let publicKey = "K7Vvzk";
    if (window.shopUrl.includes("dev")) {
      publicKey = "Wbv8q9";
    }

    const options = {
      method: "POST",
      headers: { accept: "text/html", "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        data:
          '{"token": "' +
          publicKey +
          '", "event": "Lead Gen Serving Guide", "customer_properties": {"$email": "' +
          customerEmail +
          '"}, "properties": ' + JSON.stringify(propertiesOptions) + '}',
      }),
    };

    fetch("https://a.klaviyo.com/api/track", options)
      .then((response) => response.json())
      .then((response) => console.log(response))
      .catch((err) => console.error(err));

    sgSubscriptions(formData);
  });
}

async function sgSubscriptions(form) {
  const formData = new FormData(form);
  const subscriptionsApi = await fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
    method: "POST",
    body: formData,
  });
  const response = await subscriptionsApi.json();

  document.querySelector(".sg-email-success").style.display = "block";
  document.querySelector(".sg-email-form").style.display = "none";

  if (response.errors.length > 0) {
    let htmlError = "";
    response.errors.forEach((er) => {
      htmlError += "<li>" + er + "</li>";
    });
    document.getElementById("error-klaviyo").innerHTML = htmlError;
    document.getElementById("error-klaviyo").style.display = "block";
  } else {
    let isVerified = document.querySelector(".sg-step-2").getAttribute("data-verify"),
      isEatPetzyo = document.querySelector(".sg-step-2").getAttribute("data-petzyo");

    if (isVerified == false || isVerified == "false") {
      let mail = document.getElementById("email_serving_guide").querySelector('[name="email"]').value;
      document.querySelector(".sg-step-2").setAttribute("data-mail", mail);
      document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').setAttribute("data-mail", mail);
      // if (isEatPetzyo == true || isEatPetzyo == "true") {
      // document.querySelector(".js-update-data-dog").style.display = "block";
      // } else {
      //   document.querySelector(".js-sg-recommend").style.display = "block";
      // }
    }

    // document.querySelector(".js-title-success").innerText = "We’ve emailed you your dog’s serving guide";
  }

  // Update form data to DB
  const payloadEmail = JSON.stringify({
    id: getCookie("_ruid"),
    servingGuide: {
      dog: dogsField[0],
      product: products[0],
      servingGuide: servingGuide,
      recurrence: recurrence,
    },
  });

  const dbEmail = await fetch("https://home.petzyo.com.au/api/storefront/serving-guide-email", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: payloadEmail,
  });

  const dbEmailResponse = await dbEmail.json();

  pageLoad(false);
}

function sgShowMore() {
  document.querySelector(".js-sg-showmore").addEventListener("click", (e) => {
    e.target.style.display = "none";
    document.querySelector(".description-last").style.display = "block";
  });
}

function mixBrandPetzyo() {
  if (document.querySelectorAll('.sg-other-brand-wrap .js-sg-brand[data-brand-handle="petzyo"]').length > 0) {
    document.querySelector('.sg-other-brand-wrap .js-sg-brand[data-brand-handle="petzyo"]').click();
  }
}

function pageLoad(isLoading) {
  if (isLoading) {
    document.querySelector("body").classList.add("page-loading");
  } else {
    document.querySelector("body").classList.remove("page-loading");
  }
}

function setAttributes(el, attrs) {
  for (var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
}

class ChooseDog extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="choose_dogs"]');
    if (!this.input) return;
    this.input.addEventListener("change", this.chooseDogToUpdate.bind(this));
  }

  chooseDogToUpdate() {
    document.querySelector('.sg-popup-wrap[data-popup="confirmation-code"]').setAttribute("data-dog", this.input.value);
    document.querySelector(".js-sg-update-dog-btn").disabled = false;
  }
}
customElements.define("choose-dog", ChooseDog);

class DogTab extends HTMLElement {
  constructor() {
    super();

    this.tab = this.querySelector('[name="is_adult"]');
    if (!this.tab) return;
    this.tab.addEventListener("change", this.changeTab.bind(this));
  }

  changeTab() {
    this.dataForm = this.tab.value;
    this.dataLifestage = this.querySelector("label").getAttribute("data-lifestage");

    document.querySelector(".sg-tab-content.active").classList.remove("active");
    let formActive = document.querySelector('.sg-tab-content[data-form="' + this.dataForm + '"]');
    formActive.classList.add("active");
    formActive.setAttribute("data-lifestage", this.dataLifestage);

    document.querySelector(".sg-step-2").setAttribute("data-form", this.dataForm);
    document.querySelector(".sg-step-2").setAttribute("data-lifestage", this.dataLifestage);

    checkValidateSgForm();
    checkEatPetzyo();
  }
}
customElements.define("dog-tab", DogTab);

class SgSelect extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector(".js-sg-select");
    if (!this.select) return;

    this.wrap = this;
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.select.addEventListener("click", this.open.bind(this));

    this.options = this.wrap.querySelectorAll(".js-sg-select-value");
    if (this.options.length) {
      this.options.forEach((option) => {
        option.addEventListener("click", () => {
          this.chooseOption(option);
        });
      });
    }

    if (this.wrap.querySelectorAll("input-add").length) {
      this.inputAdd = this.wrap.querySelector(".js-sg-input-search");
      this.searchWrap = this.inputAdd.closest(".sg-select-wrap");
      this.searchEle = this.searchWrap.querySelectorAll("ul.js-search-element-wrap li");
      this.searchLength = this.searchEle.length;

      const debouncedOnChange = debounce((event) => {
        this.inputAddOnChange(event);
      }, 500);

      this.inputAdd.addEventListener("keyup", debouncedOnChange.bind(this));

      if (this.wrap.querySelectorAll("select-add").length > 0) {
        this.selectAdd = this.wrap.querySelector("select-add");
        this.selectAdd.addEventListener("click", this.selectAddHandle.bind(this));
      }

      if (this.wrap.querySelectorAll("brand-add").length > 0) {
        this.brandAddButton = this.wrap.querySelector("brand-add");
        this.brandAddButton.addEventListener("click", this.brandAddHandle.bind(this));
      }
    }
  }

  open() {
    if (this.wrap.classList.contains("selected")) {
      this.wrap.classList.remove("selected");
      document.body.removeEventListener("click", this.onBodyClick);
    } else {
      if (document.querySelectorAll("sg-select.selected").length > 0) {
        document.querySelector("sg-select.selected").classList.remove("selected");
      }
      this.wrap.classList.add("selected");
    }

    document.body.addEventListener("click", this.onBodyClick);
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.wrap && !target.closest("sg-select")) {
      this.close();
    }
  }

  close() {
    if (this.wrap.classList.contains("selected")) {
      this.wrap.classList.remove("selected");
    }
    document.body.removeEventListener("click", this.onBodyClick);
  }

  chooseOption(option) {
    this.value = option.innerText || option.textContent;

    if (option.classList.contains("js-sg-breed") && document.querySelectorAll('.js-add-new-breed').length > 0) {
      document.querySelector(".js-add-new-breed").classList.remove('js-add-new-breed');
    }

    if (option.classList.contains("js-sg-brand")) {
      this.brand = option.getAttribute("data-brand-handle");
      this.brandWrap = option.closest(".sg-other-brand-wrap");

      if (this.brandWrap) {
        if (this.brandWrap.querySelectorAll(".js-sg-other-product.active").length > 0) {
          this.brandWrap.querySelector(".js-sg-other-product.active").classList.remove("active");
        }

        this.otherProduct = this.brandWrap.querySelectorAll(".js-sg-other-product:not(.hidden)");
        if (this.otherProduct.length > 0) {
          this.otherProduct.forEach((ele) => {
            ele.classList.add("hidden");
          });
        }

        this.brandToProduct = this.brandWrap.querySelectorAll('.js-sg-other-product[data-brand-handle="' + this.brand + '"]');
        if (this.brandToProduct.length > 0) {
          this.brandToProduct[0].click();
          this.brandToProduct.forEach((ele) => {
            ele.classList.remove("hidden");
          });
        }

        if (this.brandWrap.classList.contains("more-new-brands")) {
          this.brandWrap.classList.remove("more-new-brands");
        }
      }
    }

    if (option.classList.contains("js-sg-other-product")) {
      this.tof = option.getAttribute("data-tof-handle");
      this.brandWrap = option.closest(".sg-other-brand-wrap");

      this.productToTof = this.brandWrap.querySelectorAll('.js-sg-other-tof[data-tof-handle="' + this.tof + '"]');
      if (this.productToTof.length > 0) {
        this.productToTof[0].click();
      }

      this.me = option.getAttribute("data-me");
      if (this.brandWrap.querySelectorAll(".js-sg-other-me").length > 0) {
        if (this.me != "") {
          this.brandWrap.querySelector(".js-sg-other-me").value = this.me;
        } else {
          document.querySelector(".js-sg-calculate").disabled = true;
          this.brandWrap.querySelector(".js-sg-other-me").value = "";
        }
      }
    }

    if (this.wrap.querySelector(".js-sg-select").classList.contains("unselected")) {
      this.wrap.querySelector(".js-sg-select").classList.remove("unselected");
    }

    if (this.wrap.querySelectorAll(".js-sg-select-value.active").length) {
      this.oldActiveValue = this.wrap.querySelector(".js-sg-select-value.active");
      this.oldActiveValue.classList.remove("active");
    }
    option.classList.add("active");

    this.wrap.querySelector(".js-sg-select span").innerText = this.value;
    this.close();
  }

  async inputAddOnChange() {
    this.searchValue = this.inputAdd.value.toLowerCase();

    let filter = Array.prototype.filter;
    const filtered = filter.call(this.searchEle, (elm) => {
      if (elm.getAttribute("data-value").indexOf(this.searchValue) > -1) {
        // elm.classList.remove("hidden");
        elm.classList.remove("search-hidden");
      } else {
        // elm.classList.add("hidden");
        elm.classList.add("search-hidden");
      }
    });

    await Promise.all(filtered);

    if (this.closest(".sg-cf-field").classList.contains("sg-cf-field-other-product")) {
      this.searchLength = this.searchWrap.querySelectorAll("ul.js-search-element-wrap li:not(.hidden)").length;
      this.elmNotShow = this.searchWrap.querySelectorAll("ul.js-search-element-wrap li.search-hidden:not(.hidden)").length;
    } else {
      this.elmNotShow = this.searchWrap.querySelectorAll("ul.js-search-element-wrap li.search-hidden").length;
    }

    if (this.elmNotShow === this.searchLength) {
      this.searchWrap.querySelector(".sg-search-no-result").classList.remove("hidden");
    } else {
      this.searchWrap.querySelector(".sg-search-no-result").classList.add("hidden");
    }
  }

  selectAddHandle() {
    let addValue = this.inputAdd.value;
    if (addValue == "" || addValue == " ") {
      alert("Please enter your dog’s breed");
    } else {
      if (document.querySelectorAll(".js-sg-next-btn").length > 0) {
        document.querySelector(".js-sg-next-btn").classList.add('js-add-new-breed');
        window.newBreed.breed = addValue;
      }
      this.wrap.querySelector(".js-sg-select span").innerText = addValue;
      this.close();
    }
  }

  brandAddHandle() {
    let addBrandValue = this.inputAdd.value;
    if (addBrandValue == "" || addBrandValue == " ") {
      alert("Please enter brand!");
    } else {
      this.wrap.querySelector(".js-sg-select span").innerText = addBrandValue;
      document.querySelector(".sg-step-2").setAttribute("data-new-brand", true);

      this.brandWrap = this.wrap.closest(".sg-other-brand-wrap");
      if (this.brandWrap) {
        this.brandWrap.classList.add("more-new-brands");
        this.otherProductInput = this.brandWrap.querySelector(".js-sg-other-new-product");
        this.otherProductSelect = this.brandWrap.querySelector(".sg-cf-field-other-product sg-select");

        // if (this.otherProductInput && this.otherProductSelect) {
        //   this.otherProductInput.classList.remove("hidden");
        //   this.otherProductSelect.classList.add("hidden");
        // }

        this.otherMe = this.brandWrap.querySelector(".js-sg-other-me");
        if (this.otherMe) {
          this.otherMe.value = "";
        }
      }

      checkValidateSgForm();
      this.close();
    }
  }
}

customElements.define("sg-select", SgSelect);

class SgRadio extends HTMLElement {
  constructor() {
    super();

    this.radio = this.querySelector(".js-sg-radio");
    this.wrap = this.closest(".sg-cf-field");
    if (!this.radio || !this.wrap) return;

    this.radio.addEventListener("change", this.changeHandle.bind(this));
  }

  changeHandle() {
    if (this.wrap.querySelectorAll(".sg-radio.selected").length) {
      this.wrap.querySelector(".sg-radio.selected").classList.remove("selected");
    }
    this.radio.closest(".sg-radio").classList.add("selected");

    if (this.radio.classList.contains("js-check-validate")) {
      checkValidateSgForm();
    }
    if (this.radio.classList.contains("js-sg-eats-petzyo")) {
      checkEatPetzyo();
    }
  }
}

customElements.define("sg-radio", SgRadio);
